//Loading Indicators Reducer


const loadingReducerDefaultState = {
    isLoadingData           : true,
    isLoadingPartsData      : true,
    isButtonLoadedData      : false,
    isButtonLoadedPartsData : false,
    isReset                 : false
};

export default (state = loadingReducerDefaultState, action) => {
    switch(action.type) {
        case 'SET_LOADING_INDICATOR':
            return {
                ...state,
                isLoadingData : action.isLoading
            };
        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/Reducers/loading.js